import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * @param dirty - The potentially unsafe HTML string
 * @returns The sanitized HTML string
 */
export const sanitizeHtml = (dirty: string): string => {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'br', 'p', 'span', 'div', 'ul', 'ol', 'li', 'a'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOW_DATA_ATTR: false,
  });
};

/**
 * Sanitizes user input for display as plain text
 * @param input - The user input string
 * @returns The sanitized string
 */
export const sanitizeText = (input: string): string => {
  // Remove any HTML tags and encode special characters
  const div = document.createElement('div');
  div.textContent = input;
  return div.innerHTML;
};

/**
 * Sanitizes property data to prevent XSS in dynamic content
 * @param property - The property object with potentially unsafe data
 * @returns The property object with sanitized fields
 */
export const sanitizePropertyData = (property: any): any => {
  if (!property) return property;
  
  return {
    ...property,
    address: property.address ? sanitizeText(property.address) : property.address,
    description: property.description ? sanitizeText(property.description) : property.description,
    listingAgent: property.listingAgent ? sanitizeText(property.listingAgent) : property.listingAgent,
    subdivision: property.subdivision ? sanitizeText(property.subdivision) : property.subdivision,
    listingOfficeName: property.listingOfficeName ? sanitizeText(property.listingOfficeName) : property.listingOfficeName,
  };
};